/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Fact_WeekInputs */

const en_us2_profile_fact_week = /** @type {(inputs: Profile_Fact_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`week`)
};

const pt_br2_profile_fact_week = /** @type {(inputs: Profile_Fact_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`semana`)
};

const es_419_profile_fact_week = /** @type {(inputs: Profile_Fact_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`semana`)
};

const pt_pt2_profile_fact_week = /** @type {(inputs: Profile_Fact_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`semana`)
};

const fr_fr2_profile_fact_week = /** @type {(inputs: Profile_Fact_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`semaine`)
};

const de_de2_profile_fact_week = /** @type {(inputs: Profile_Fact_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche`)
};

const it_it2_profile_fact_week = /** @type {(inputs: Profile_Fact_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`settimana`)
};

/**
* | output |
* | --- |
* | "week" |
*
* @param {Profile_Fact_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_fact_week = /** @type {((inputs?: Profile_Fact_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Fact_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_fact_week(inputs)
	if (locale === "es-419") return es_419_profile_fact_week(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_fact_week(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_fact_week(inputs)
	if (locale === "de-DE") return de_de2_profile_fact_week(inputs)
	if (locale === "it-IT") return it_it2_profile_fact_week(inputs)
	return en_us2_profile_fact_week(inputs)
});
export { profile_fact_week as "profile.fact_week" }